import { render, staticRenderFns } from "./BoxRoomPrice.vue?vue&type=template&id=b6474e46&scoped=true&"
import script from "./BoxRoomPrice.vue?vue&type=script&lang=ts&"
export * from "./BoxRoomPrice.vue?vue&type=script&lang=ts&"
import style0 from "./BoxRoomPrice.vue?vue&type=style&index=0&id=b6474e46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6474e46",
  null
  
)

export default component.exports